export enum QueryKey {
  campaignManagerContextUseCampaigns = 'campaignManagerContextUseCampaigns',
  selectedCampaignContextUseCandidates = 'selectedCampaignContextUseCandidates',
  useRatedCandidatesQuery = 'useRatedCandidatesQuery',
  useRatedCandidatesStats = 'useRatedCandidatesStats',
  selectedCampaignContextUseStats = 'selectedCampaignContextUseStats',
  selectedCampaignContextUseFacets = 'selectedCampaignContextUseFacets',
  sharedCandidateContextUseCandidate = 'sharedCandidateContextUseCandidate',
  selectedCampaignContextUseCandidateMatches = 'selectedCampaignContextUseCandidateMatches',
  useCandidateActivityLogQuery = 'useCandidateActivityLogQuery',
  useRJActivityLogsQuery = 'useRJActivityLogsQuery',
  useGetRjBulkUsageQuery = 'useGetRjBulkUsageQuery',
  useCandidateHistoryQuery = 'useCandidateHistoryQuery',
  frontend2beCandidate = 'frontend2beCandidate',
  connectToAtsUseAts = 'connectToAtsUseAts',
  campaignManagerContextUseCampaign = 'campaignManagerContextUseCampaign',
  useTenantDistinctedLabelsQuery = 'useTenantDistinctedLabelsQuery',
  useRequestCv = 'useRequestCv',
  sharedPageMatches = 'sharedPageMatches',
  useOutreachTemplateByTypeQuery = 'useOutreachTemplateByTypeQuery',
  useUserEmailSignatureQuery = 'useUserEmailSignatureQuery',
  useCurrentUserQuery = 'useCurrentUserQuery',
  useGetCampaignNewRepliesQuery = 'useGetCampaignNewRepliesQuery',
  useExistsLinkedinInmailConversationWithCandidateQuery = 'useExistsLinkedinInmailConversationWithCandidateQuery',
  useExistsLinkedinConversationWithCandidateQuery = 'useExistsLinkedinConversationWithCandidateQuery',
  useGetUnreadConversationsAmount = 'useGetUnreadConversationsAmount',
  useCheckHasLinkedinFreeInviteRemainingQuery = 'useCheckHasLinkedinFreeInviteRemainingQuery',
  searchRatedCandidate = 'searchRatedCandidate',
  useCandidateNotesQuery = 'useCandidateNotesQuery',
  atsCandidateStatusesQuery = 'atsCandidateStatusesQuery',
  atsApplicationStatusesQuery = 'atsApplicationStatusesQuery',
  atsAvailableJobStatusesQuery = 'atsAvailableJobStatusesQuery',
  atsSelectedJobStatusesQuery = 'atsSelectedJobStatusesQuery',
  atsAvailableJobLabelsQuery = 'atsAvailableJobLabelsQuery',
  atsSelectedJobLabelsQuery = 'atsSelectedJobLabelsQuery',
  atsAvailableCandidateStatusesQuery = 'atsAvailableCandidateStatusesQuery',
  atsSelectedCandidateStatusesQuery = 'atsSelectedCandidateStatusesQuery',
  atsAvailableCandidateLabelsQuery = 'atsAvailableCandidateLabelsQuery',
  atsSelectedCandidateLabelsQuery = 'atsSelectedCandidateLabelsQuery',
  validAtsForRobinResume = 'validAtsForRobinResume',
  useTenantUsersQuery = 'useTenantUsersQuery',
  useTenantUserQuery = 'useTenantUserQuery',
  useIndeedLicensesQuery = 'useIndeedLicensesQuery',
  useBrowserExtensionStatusQuery = 'useBrowserExtensionStatusQuery',
  useIndeedCommonModelQuery = 'useIndeedCommonModelQuery',
  useIndeedProjectListQuery = 'useIndeedProjectListQuery',
  useIndeedJobsListQuery = 'useIndeedJobsListQuery',
  useIndeedSubscriptionsListQuery = 'useIndeedSubscriptionsListQuery',
  useActiveIndeedLicenseQuery = 'useActiveIndeedLicenseQuery',
  useIndeedUsersListQuery = 'useIndeedUsersListQuery',
  useFeatureTogglesQuery = 'useFeatureTogglesQuery',
  useIndeedModalsUpdatedLicenses = 'useIndeedModalsUpdatedLicenses',
  useIndeedModalsAudit = 'useIndeedModalsAudit',
  countUnreadIndeedMessages = 'countUnreadIndeedMessages',
  getNewIndeedMessages = 'getNewIndeedMessages',
  getIndeedContactSummary = 'getIndeedContactSummary',
  getMyCampaigns = 'getMyCampaigns',
  useIndeedJobListQuery = 'useIndeedJobListQuery',
  useLinkedinConfig = 'useLinkedinConfig',
  useSearchJobTitleAutocompleteQuery = 'useSearchJobTitleAutocompleteQuery',
  useHasValidAtsConnectionQuery = 'useHasValidAtsConnectionQuery',
  useGetUser = 'getUser',
  useGetUsers = 'getUsers',
  getConversations = 'getConversations',
  getConversationsPreview = 'getConversationsPreview',
  useAtsVacancyQuery = 'useAtsVacancyQuery',
  useEnrichedVacanciesQuery = 'useEnrichedVacanciesQuery',
  useAtsVacancyFullQuery = 'useAtsVacancyFullQuery',
  getInfiniteConversations = 'getInfiniteConversations',
  getCandidatesBasedOnEsPersonId = 'getCandidatesBasedOnEsPersonId',
  getBatchConversationsBasedOnEsPersonIds = 'getBatchConversationsBasedOnEsPersonIds',
  getUnreadButtonAvailability = 'getUnreadButtonAvailability',
  SearchEsCampaignCandidate = 'SearchEsCampaignCandidate',
  reachoutConversionSummaryData = 'reachoutConversionSummaryData',
  dashboardSummary = 'dashboardSummary',
  vectorSearchStatus = 'vectorSearchStatus',
  useProcessVacancyQuery = 'useProcessVacancyQuery',
  useCombinedVacanciesQuery = 'useCombinedVacanciesQuery',
  useProcessVacancy = 'useProcessVacancy',
  useProcessAtsVacancy = 'useProcessAtsVacancy',
  useDashboardLeaderboardInfiniteQuery = 'useDashboardLeaderboardInfiniteQuery',
  useDashboardUsersQuery = 'useDashboardUsersQuery',
  useJobImprovedQuery = 'useJobImprovedQuery',
  usePublicVacancyQuery = 'usePublicVacancyQuery',
  useCampaignCandidateQuery = 'useCampaignCandidateQuery',
  useCandidateCampaignQuery = 'useCandidateCampaignQuery',
  useOauthNylasStatusQuery = 'useOauthNylasStatusQuery',
  useSchedulingLinkQuery = 'useSchedulingLinkQuery',
  useConnectedEmailAccountDetailsQuery = 'useConnectedEmailAccountDetailsQuery',
  useLinkedinInMailCredits = 'useLinkedinInMailCredits',
  useGetJobImproved = 'useGetJobImproved',
  useGetAllAtsConnectionsQuery = 'useGetAllAtsConnectionsQuery',
  useRefreshToken = 'useRefreshToken',
  useJobImprovedJobPreviewQuery = 'useJobImprovedJobPreviewQuery',
  useGetCandidateQuestionaryQuery = 'useGetCandidateQuestionaryQuery',
  useCandidateQuestionaryMutation = 'useCandidateQuestionaryMutation',
  useGetCandidateProfileQuery = 'useGetCandidateProfileQuery',
  useCandidateProfileMutation = 'useCandidateProfileMutation',
  useJobPreviewQuery = 'useJobPreviewQuery',
  useGenerateJobPreviewMutation = 'useGenerateJobPreviewMutation',
  useGenerateEnrichedVersionMutation = 'useGenerateEnrichedVersionMutation',
  useAutoProcessJobPreviewVacancy = 'useAutoProcessJobPreviewVacancy',
  useCandidateHasMessagesQuery = 'useCandidateHasMessagesQuery',
  useGetCandidateJobSearchQuery = 'useGetCandidateJobSearchQuery',
  useSendMessageMutation = 'useSendMessageMutation',
  useGetMessagesQuery = 'useGetMessagesQuery',
  useGetChatQuery = 'useGetChatQuery',
  useSaveJobPreviewMutation = 'useSaveJobPreviewMutation',
  useBestMatchesInfiniteQuery = 'useBestMatchesInfiniteQuery',
  useHideCandidateMutation = 'useHideCandidateMutation',
  useCreateChatMutation = 'useCreateChatMutation',
  useGetJobPreviewQuery = 'useGetJobPreviewQuery',
  useQuestionnairePreviewQuery = 'useQuestionnairePreviewQuery',
  useQuestionnaireConfigurationQuery = 'useQuestionnaireConfigurationQuery',
  useCreateCampaignMutation = 'useCreateCampaignMutation',
  useChatOverviewInfiniteQuery = 'useChatOverviewInfiniteQuery',
  useGenerateReachoutMessageMutation = 'useGenerateReachoutMessageMutation',
  useGenerateReachoutMessageFromIdsMutation = 'useGenerateReachoutMessageFromIdsMutation',
  useStartRJCommunicationPipelineMutation = 'useStartRJCommunicationPipelineMutation',
  useAtsVacancyListQuery = 'useAtsVacancyListQuery',
  useJobImprovedListQuery = 'useJobImprovedListQuery',
  useAutoProcessAtsVacancyJobImprovedSelection = 'useAutoProcessAtsVacancyJobImprovedSelection',
  useGetChatJobImproved = 'useGetChatJobImproved',
  useGetActivityLogQuery = 'useGetActivityLogQuery',
  useGetFeatureToggles = 'useGetFeatureToggles',
  useGetRobinJrActivityLogQuery = 'useGetRobinJrActivityLogQuery',
  useGetHistoryQuery = 'useGetHistoryQuery',
  useCancelFollowUpMutation = 'useCancelFollowUpMutation',
  useSaveCandidateEmailMutation = 'useSaveCandidateEmailMutation',
  useGetNylasConnectionStatusQuery = 'useGetNylasConnectionStatusQuery',
  useGetAddressQuery = 'useGetAddressQuery',
  useSaveSchedulerConfigMutation = 'useSaveSchedulerConfigMutation',
  useGetNylasOauthUrlQuery = 'useGetNylasOauthUrlQuery',
  useGetSchedulerConfigQuery = 'useGetSchedulerConfigQuery',
  useGetTenantBrandingQuery = 'useGetTenantBrandingQuery',
  useGetTeamsQuery = 'useGetTeamsQuery',
  useGetBrandingTeamsQuery = 'useGetBrandingTeamsQuery',
  useGetTenantOwnBrandingQuery = 'useGetTenantOwnBrandingQuery',
  useRejectCandidateMutation = 'useRejectCandidateMutation',
  useDeactivateCandidateRecommendationsMutation = 'useDeactivateCandidateRecommendationsMutation',
  useNotifyMeCandidateRecommendationsMutation = 'useNotifyMeCandidateRecommendationsMutation',
  useGetCandidateInterviewFeedbackQuery = 'useGetCandidateInterviewFeedbackQuery',
  useGetRecruiterInterviewFeedbackQuery = 'useGetRecruiterInterviewFeedbackQuery',
  useSubmitCandidateInterviewFeedbackMutation = 'useSubmitCandidateInterviewFeedbackMutation',
  useSubmitRecruiterInterviewFeedbackMutation = 'useSubmitRecruiterInterviewFeedbackMutation',
}
